import Api from './Connector.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { message } from 'antd';
import { t } from 'i18next';
import { createAsyncThunk } from '@reduxjs/toolkit';

const connectionDetails = new Api('services/', 'pluginserv');
const sellerReportDetails = new Api('services/', 'seller_report');

export const retryFailedSteps = async (retryList, setIsRetryLoading, loadStepDetails) => {
  let apiData = {};
  if (retryList.length <= 0) {
    message.error(t('GRAAS_PLEASE_SELECT_ATLEASE_ONE_FAILED_STEP_GRAAS'));
    return;
  }
  setIsRetryLoading(true);
  try {
    let payload = { pluginDocIDs: retryList };
    apiData = await connectionDetails.retryFailedSteps(payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      message.success(t('GRAAS_RETRY_INITIATED_GRAAS'));
      loadStepDetails();
    }
  } catch (error) {
    apiData = { status: 'failure' };
    throw new UserError(error);
  }
  setIsRetryLoading(false);
  return apiData;
};

export const getNewConnectionDetails = createAsyncThunk(
  'connector/getNewConnectionDetails',
  async (payload, { rejectWithValue }) => {
    try {
      let apiData = await connectionDetails.getNewConnectionDetails(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export const getStoreStepDetails = createAsyncThunk(
  'connector/getStoreStepDetails',
  async (payload, { rejectWithValue }) => {
    try {
      let apiData = await sellerReportDetails.getStoreStepDetails(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      throw new UserError(error);
    }
  }
);

export const getStoreStepDetailsLastUpdate = createAsyncThunk(
  'connector/getStoreStepDetailsLastUpdate',
  async (payload, { rejectWithValue }) => {
    try {
      let apiData = await sellerReportDetails.getStoreStepDetails(payload);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        return data;
      }
    } catch (error) {
      throw new UserError(error);
    }
  }
);

export const getReportSummary = createAsyncThunk('connector/getReportSummary', async (payload, { rejectWithValue }) => {
  try {
    let apiData = await sellerReportDetails.getReportSummary(payload);
    if (apiData && apiData.hasError) {
      throw apiData;
    } else {
      const { data } = apiData;
      return data;
    }
  } catch (error) {
    rejectWithValue(error);
  }
});
